module.exports = __webpack_public_path__ + "img/zdd_invite_feature_1.f3a28af1.png";